<template>
    <form @submit.prevent="submit">
        <GroupStudentClassroomSelect
            :classroom-options="classroomOptions"
            :instructor-options="instructorOptions"
            v-model="form.classroomId"
        />

        <!--        <form-select-->
        <!--            label=""-->
        <!--            name="classroom_id"-->
        <!--            v-model="form.classroomId"-->
        <!--            :options="classroomOptions"-->
        <!--            :css-classes="-->
        <!--                'mb-0' +-->
        <!--                (form.classroomId === null ? 'text-gray-650' : 'border-none')-->
        <!--            "-->
        <!--            wrapper-css-classes="mb-0"-->
        <!--            :allow-null="true"-->
        <!--            :null-option="-->
        <!--                student.classroom?.id ? 'None' : '+ Assign to classroom'-->
        <!--            "-->
        <!--        />-->
    </form>
</template>
<script>
import FormSelect from "@/Components/FormSelect";
import GroupStudentClassroomSelect from "@/Pages/GroupBackend/GroupStudentClassroomSelect.vue";

export default {
    name: "GroupStudentClassroomSelectAndChange",
    components: {
        GroupStudentClassroomSelect,
        FormSelect,
    },
    props: {
        instructorOptions: {
            type: Array,
            default: [],
        },
        classroomOptions: {
            type: Array,
            default: [],
        },
        student: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                classroomId: this.student.classroom?.id,
            }),
        };
    },
    methods: {
        submit() {
            this.$inertia.post(
                route("group.student.change-classroom", {
                    user: this.student.id,
                }),
                { classroomId: this.form.classroomId },
                {
                    preserveScroll: true,
                }
            );
        },
    },
    watch: {
        "form.classroomId": {
            handler(newValue, oldValue) {
                this.submit();
            },
            deep: false,
        },
    },
};
</script>
